<template>
  <!-- 单选树控件，带自动补全的搜索定位 -->
  <div style="height: 100%">
    <a-row
      v-if="loading"
      type="flex"
      justify="center"
      align="middle"
      class="loading-area"
    >
      <div>
        <a-icon type="loading" class="loading-icon" />
        <p>{{ $t('orgTree.orgLoading') }}</p>
      </div>
    </a-row>

    <a-auto-complete
      v-if="!loading"
      style="width: 100%"
      @select="handleAutoCompleteSelect"
      @search="handleAutoCompleteSearch"
      :placeholder="$t('orgTree.searchOrgTxt')"
      optionLabelProp="value"
      :value="searchText"
    >
      <template slot="dataSource">
        <a-select-option
          v-for="unit in matchArrs"
          :key="unit.id"
          :value="unit.name"
          :selcetedData="unit"
          :title="unit.name"
        >
          <span
            v-for="(item, index) in unit.name.split(searchText)"
            :key="index"
          >
            {{ item
            }}<span
              v-if="index != unit.name.split(searchText).length - 1"
              style="color: #ff5500"
              >{{ searchText }}</span
            >
          </span>
        </a-select-option>
      </template>
      <a-input>
        <a-icon slot="suffix" type="search" class="certain-category-icon" />
      </a-input>
    </a-auto-complete>

    <div v-if="!loading" class="tree-area" ref="treeArea">
      <a-tree
        class="draggable-tree"
        :blockNode="true"
        :showLine="true"
        :showIcon="true"
        :replaceFields="replaceFields"
        :autoExpandParent="autoExpandParent"
        :expandedKeys="expandedKeys"
        :selectedKeys="selectedKeys"
        :treeData="orgTreeSourceData"
        @select="onSelect"
        @expand="onExpand"
      >
        <a-icon type="down" slot="switcherIcon" />
        <template slot="custom" slot-scope="item">
          <span class="tree-node-content" :ref="item.id">{{ item.name }}</span>
          <a-icon
            class="tree-node-btn"
            v-if="!item.parentId"
            type="redo"
            :title="$t('orgTree.refreshOrg')"
            @click="() => refreshTree()"
          />
        </template>
      </a-tree>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
export default {
  name: '',
  components: {},
  props: {
    mixNodeName: {
      type: Boolean,
      default: false
    },
    selectedData: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      // 获取组织数据中
      loading: false,

      searchText: this.selectedData ? this.selectedData.name : '',
      matchArrs: [],
      // selcetedData: '',

      // 树
      replaceFields: {
        key: 'id',
        title: 'name'
      },
      expandedKeys: this.selectedData ? this.selectedData.expandedList : [],
      selectedKeys: this.selectedData ? [this.selectedData.id] : [],
      autoExpandParent: true
    }
  },
  computed: {
    ...mapState({
      orgTreeSourceData: state => state.orgStore.orgTreeSourceData
    }),
    ...mapGetters(['orgAutoCompletedSourceData'])
  },
  watch: {},
  created() {
    this.expandedKeys = this.expandedKeys.length
      ? this.expandedKeys
      : [this.orgAutoCompletedSourceData[0].id]
    this.setTreeAreaScrollTop()
  },
  methods: {
    ...mapActions(['getOrgTreeSourceData']),

    handleAutoCompleteSearch(searchText) {
      let matchArrs
      if (!searchText) {
        matchArrs = []
      } else {
        matchArrs = this.orgAutoCompletedSourceData.filter(item => {
          return item.name.indexOf(searchText) !== -1
        })
      }
      this.searchText = searchText
      this.matchArrs = matchArrs
    },
    handleAutoCompleteSelect(value, vnode) {
      // console.log('handleAutoCompleteSelect', value, vnode);
      this.searchText = value
      this.selcetedData = vnode.data.attrs.selcetedData
      this.expandedKeys = this.selcetedData.expandedList.slice(
        0,
        this.selcetedData.expandedList.length - 1
      )
      this.selectedKeys = [this.selcetedData.id]

      this.setTreeAreaScrollTop()
      this.$emit('update:selectedOrg', this.selcetedData)
    },
    setTreeAreaScrollTop() {
      // 当组织树渲染好后，再通过ref定位选中对象并设置scrollTop
      setTimeout(() => {
        // this.$refs.treeArea.scrollTop = this.$refs[this.selcetedData.id].offsetParent.offsetTop
        if (this.$refs[this.selectedKeys[0]]) {
          this.$refs.treeArea.scrollTop = this.$refs[
            this.selectedKeys[0]
          ].offsetParent.offsetTop
        }
      }, 500)
    },

    onExpand(expandedKeys) {
      // console.log('onExpand', expandedKeys);
      this.expandedKeys = expandedKeys
      this.autoExpandParent = false
    },
    onSelect(selectedKeys, vnode) {
      // console.log('selected', selectedKeys, vnode);
      if (vnode.selected) {
        this.selectedKeys = selectedKeys
        this.selcetedData = this.orgAutoCompletedSourceData.find(
          item => item.id === this.selectedKeys[0]
        )
        this.searchText = this.selcetedData.name

        this.$emit('update:selectedOrg', this.selcetedData)
      }
    },

    async refreshTree(selectedData) {
      await this.getOrgTreeSourceData()

      if (selectedData) {
        this.selcetedData = selectedData
        this.searchText = selectedData.name
        this.expandedKeys = selectedData.expandedList
        this.selectedKeys = [selectedData.id]

        this.setTreeAreaScrollTop()
      }
    }
  }
}
</script>

<style scoped>
.loading-area {
  text-align: center;
  color: #1890ff;
  height: 590px;
}
.loading-area .loading-icon {
  font-size: 32px;
  margin-bottom: 20px;
}
.tree-area {
  /* height: 590px; */
  height: calc(100% - 16px - 32px);
  overflow: auto;
  margin-top: 16px;
  position: relative;
}
.tree-area > .ant-tree {
  position: absolute;
  min-width: 100%;
}
.tree-node-content {
  /* width: calc(100% - 22px);
  display: inline-block;
  overflow: hidden;
  text-overflow:ellipsis;
  white-space: nowrap; */
  padding-right: 20px;
}
.tree-node-btn {
  float: right;
  height: 24px;
  padding: 4px;
}
</style>
